export const LOGIN_USER = "LOGIN_USER";
export const DASHBOARD = "DASHBOARD";
export const CONTACT = "CONTACT";
